import { render } from "./footer.vue?vue&type=template&id=4abd26ad&scoped=true&ts=true"
import script from "./footer.vue?vue&type=script&lang=ts"
export * from "./footer.vue?vue&type=script&lang=ts"

import "./footer.vue?vue&type=style&index=0&id=4abd26ad&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4abd26ad"]])

export default __exports__